import { clientApiCall } from "./apiCallWrapper";
import type { ProductDeliveryResponse } from "./types/delivery";

/** Клиентский API информации о доставке товара Bitrix bxApi (/delivery/*). */
export default (_axios: any, config: any) => ({
  getProductsDeliveryNew(
    productId: string | number,
  ): Promise<ProductDeliveryResponse | null> {
    return clientApiCall<ProductDeliveryResponse>(
      `${config.API_URL}/delivery/getProductsDeliveryNew`,
      {
        api: "delivery.getProductsDeliveryNew",
        params: { productId },
        skipForRobots: true,
      },
    );
  },
});
